import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	organizationsBreadcrumb: {
		id: 'fastshift.dc-instance-details.organizations-breadcrumb',
		defaultMessage: 'Organizations',
		description: 'Breadcrumb label linking to the FastShift organizations list.',
	},
	pageTitleFallback: {
		id: 'fastshift.dc-instance-details.page-title-fallback',
		defaultMessage: 'Unknown Data Center instance',
		description: 'Fallback title for a Data Center instance when its base URL is not available.',
	},
	errorDescription: {
		id: 'fastshift.dc-instance-details.error-description',
		defaultMessage: 'We’re unable to load this page right now',
		description: 'Message displayed when the Data Center instance details request fails.',
	},
	jiraDataCenterLabel: {
		id: 'fastshift.dc-instance-details.jira-data-center-label',
		defaultMessage: 'Jira Data Center',
		description: 'Product label above the base URL for a Jira Data Center instance.',
	},
	confluenceDataCenterLabel: {
		id: 'fastshift.dc-instance-details.confluence-data-center-label',
		defaultMessage: 'Confluence Data Center',
		description: 'Product label above the base URL for a Confluence Data Center instance.',
	},
	dataCenterLabelFallback: {
		id: 'fastshift.dc-instance-details.data-center-label-fallback',
		defaultMessage: 'Data Center',
		description: 'Fallback product label when the Data Center product type is unavailable.',
	},
	loadingLabel: {
		id: 'fastshift.dc-instance-details.loading-label',
		defaultMessage: 'Loading Data Center instance details',
		description: 'Accessible label for the DC instance details page loading indicator.',
	},
});
